import { makeRoute } from '~/utils/route';
import controller from './class-designer.controller';
import template from './class-designer.html';
import './class-designer.scss';

export default makeRoute({
	path:        '/admin/class-designer/beta',
	template,
	controller,
	title:       'menu.class-designer',
});
